<template>
  <div class="context-source-text mb-3" v-html="text.source_text"></div>
</template>
<script>
  import Ncs from 'ncs'

  export default {
    extends: Ncs.defaultComponents.NcsContextSourceText
  }
</script>